<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">{{ $t('This form has been sent successfully.') }} <i>¡Gracias! </i>
      </h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>
      <div class="field">
        <label class="label">{{ $t('Name of event organiser') }}</label>
        <div class="control">
          <input v-model="nameOfEventOrganiser" class="input" type="text">
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Email of event organiser') }}</label>
        <div class="control">
          <input v-model="emailOfEventOrganiser" type="email" class="input">
          <div class="has-text-error-message" v-if="v$.emailOfEventOrganiser.$error">{{ $t('email') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Name of event') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="nameOfEvent" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.nameOfEvent.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Name of venue') }}</label>
        <div class="control">
          <input v-model="nameOfVenue" type="text" class="input">
        </div>
      </div>

      <label class="label">{{ $t('Address') }}</label>
      <div class="field">
        <label class="label">{{ $t('Country') }}</label>
        <div class="select is-fullwidth">
          <select v-model="country">
            <option v-for="country in countries" :value="country.value" :key="country.label">
              {{ country.label }}
            </option>
          </select>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Address 1') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="address" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.address.$error">{{ $t('nec') }}</div>
      </div>

      <div class="fields ">
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('Postal code') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="postalCode" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.postalCode.$error">{{ $t('nec') }}</div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('City') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="city" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.city.$error">{{ $t('nec') }}</div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('Province') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="province" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.province.$error">{{ $t('nec') }}</div>
            </div>
          </div>
        </div>
      </div>

      <label class="label">{{ $t('Date and time') }}</label>
      <div v-for="(date,i) in datesAndTimes" :key="i" class="columns">

        <div class="column is-5">
          <label class="label">{{ $t('From') }}</label>
          <div class="field">
            <label class="label">{{ $t('Date') }}</label>
            <div class="control">
              <input v-model="date.dateFrom" type="date">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $t('Time') }}</label>
            <div class="control">
              <input v-model="date.timeFrom" type="time" class="input">
            </div>
          </div>
        </div>

        <div class="column is-5">
          <label class="label">{{ $t('To') }}</label>
          <div class="field">
            <label class="label">{{ $t('Date') }}</label>
            <div class="control">
              <input v-model="date.dateTo" type="date" class="input">
            </div>
          </div>
          <div class="field">
            <label class="label">{{ $t('Time') }}</label>
            <div class="control">
              <input v-model="date.timeTo" type="time" class="input">
            </div>
          </div>
        </div>

        <div class="column is-2">
          <button style="background: #D37700 !important; font-size: 14px; padding: 20px 0px;border: none" v-if="i>0"
                  class="button is-uppercase has-text-weight-bold is-fullwidth has-text-white" @click="removeDate(i)"
                  type="button">X
          </button>
        </div>
      </div>

      <div class="pb-5">
        <button style="background: #D37700 !important; font-size: 14px; padding: 20px 40px;border: none"
                v-if="datesAndTimes.length<5"
                class="button is-info is-uppercase has-text-weight-bold" @click="addDate" type="button">{{ $t('Add Date') }}
        </button>
      </div>

      <div class="field">
        <label class="label">{{ $t('Event information') }}</label>
        <div class="control">
          <textarea v-model="eventInfo" class="textarea"></textarea>
        </div>
      </div>

      <label class="label">{{ $t('Event Image: please upload an image of your venue') }}</label>
      <div class="uploader uploader1">
        <file-upload v-show="files.length == 0"
                     input-id="file1"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file1"
                     v-model="files"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader2'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB') }}.
              <br>
              {{ $t('Allowed file types: gif jpg jpeg') }}.
            </div>
          </div>

        </file-upload>
        <div v-if="files.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>


      </div>


      <label class="label">{{ $t('Thumbnail') }}</label>

      <div class="uploader uploader2">

        <file-upload v-show="files2.length == 0"
                     input-id="file2"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file2"
                     v-model="files2"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader1'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile2"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB') }}.
              <br>
              {{ $t('Allowed file types: gif jpg jpeg') }}.
            </div>
          </div>

        </file-upload>
        <div v-if="files2.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files2.length ? files2[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files2[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files2=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>

      </div>


      <div class="field">
        <label class="label">{{ $t('Contact email for event') }}</label>
        <div class="control">
          <input v-model="contactEmailForEvent" type="email" class="input">
          <div class="has-text-error-message" v-if="v$.contactEmailForEvent.$error">{{ $t('nec') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Website') }}</label>
        <div class="control">
          <input v-model="website" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.website.$error">{{ url }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Reservations required') }}</label>
        <div class="select is-fullwidth">
          <select v-model="reservations">
            <option value="_none">- None -</option>
            <option value="0">No</option>
            <option value="1">Yes</option>
          </select>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Age range') }}</label>
        <div class="select is-fullwidth">
          <select v-model="ageRange">
            <option value="">- None -</option>
            <option value="18 and over">18 and over</option>
            <option value="21 and over">21 and over</option>
            <option value="61">Unrestricted</option>
          </select>
        </div>
      </div>

      <!-- v-for  -->

      <label class="label">{{ $t('Event Type') }}</label>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox" type="checkbox" name="exampleRtlCheckbox" v-model="eventTypes.mediaAndTrade">
        <label for="exampleRtlCheckbox">{{ $t('Media and trade') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox1" type="checkbox" name="exampleRtlCheckbox1" v-model="eventTypes.onlineEvent">
        <label for="exampleRtlCheckbox1">{{ $t('Online event') }}</label>
      </div>
<!--      <div class="field">-->
<!--        <input class="is-checkradio" id="exampleRtlCheckbox2" type="checkbox" name="exampleRtlCheckbox2" v-model="eventTypes.sherryPairingMenu">-->
<!--        <label for="exampleRtlCheckbox2">{{ $t('Sherry Pairing Menu') }}</label>-->
<!--      </div>-->

      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox3" type="checkbox" name="exampleRtlCheckbox3" v-model="eventTypes.sherryTasting">
        <label for="exampleRtlCheckbox3">{{ $t('Sherry Tasting') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox4" type="checkbox" name="exampleRtlCheckbox4" v-model="eventTypes.sherryCocktails">
        <label for="exampleRtlCheckbox4">{{ $t('Sherry Cocktails') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox5" type="checkbox" name="exampleRtlCheckbox5" v-model="eventTypes.sherryTourism">
        <label for="exampleRtlCheckbox5">{{ $t('Sherry Tourism') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox6" type="checkbox" name="exampleRtlCheckbox6" v-model="eventTypes.sherryRetail">
        <label for="exampleRtlCheckbox6">{{ $t('Sherry Retail Promotion') }}</label>
      </div>
      <div class="field">
        <input class="is-checkradio" id="exampleRtlCheckbox7" type="checkbox" name="exampleRtlCheckbox7" v-model="eventTypes.sheryyAcademy">
        <label for="exampleRtlCheckbox7">{{ $t('Sherry Academy') }}</label>
      </div>

      <label class="label">{{ $t('Please subscribe me to your newsletter') }}</label>
      <div class="field">
        <input v-model="newsletter" class="is-checkradio" id="newsletterCheckbox" type="checkbox"
               name="newsletterCheckbox"
               checked="checked">
        <label for="newsletterCheckbox">{{ $t('I accept to recieve promotions, offers and commercial communications') }}</label>
      </div>

      <div class="field">
        <label class="label">{{ $t('Url for Facebook (not for publication)') }}</label>
        <div class="control">
          <input v-model="facebook" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.facebook.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Handle for instagram (not for publication)') }}</label>
        <div class="control">
          <input v-model="instagram" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.instagram.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Handle for Twitter (not for publication)') }}</label>
        <div class="control">
          <input v-model="twitter" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <label class="label">{{ $t('Show in sherry academy') }}</label>
      <div class="field">
        <input v-model="showInSherry" class="is-checkradio" id="showInSherryCheckbox" type="checkbox"
               name="showInSherryCheckbox"
               checked="checked">
        <label for="showInSherryCheckbox">{{ $t('Show in sherry academy') }}</label>
      </div>

      <br/>
      <div class="field">
        <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
               checked="checked">
                         <label for="termsAndConditionsCheckbox">{{ $t('I accept the conditions laid out in the')}}
                          <a target="_blank" style="color: #D37700; text-decoration: underline" href="https://www.sherry.wine/es/privacy">{{ $t('Privacy Policy')}}</a>
                          <span class="required"> *</span>
                        </label>
        <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec') }}{{ $t('nec') }}</div>
      </div>


      <div class="pt-5">
        <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send') }}
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";
import Datepicker from 'vuejs-datepicker';

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

const time = helpers.regex(/^(0?[1-9]|1[012]):[0-5][0-9]$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));
const TODAY = new Date();
const MON = (TODAY.getMonth() + 1) < 10 ? ('0' + (TODAY.getMonth() + 1)) : (TODAY.getMonth() + 1);
const DAY = (TODAY.getDate()) < 10 ? ('0' + (TODAY.getDate())) : (TODAY.getDate());
const CUR_DATE = TODAY.getFullYear() + '-' + MON + '-' + DAY;

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Events',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
    Datepicker,
  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String

  },
  data() {
    return {
      sending: false,

      success: false,
      files: [],
      files2: [],
      f1: null,
      f2: null,

      nec: "Este campo es necesario",
      mail: "Este campo tiene que ser un email",
      url: "Este campo tiene que ser un url",
      tel: "Este campo tiene que ser telefono",
      cpe: "Este campo tiene que un código postal",

      nameOfEventOrganiser: '',
      emailOfEventOrganiser: '',
      nameOfEvent: '',
      nameOfVenue: '',
      country: null,
      address: '',
      postalCode: '',
      city: '',
      province: '',

      datesAndTimes: [
        {
          dateFrom: CUR_DATE,
          timeFrom: '00:00',
          dateTo: CUR_DATE,
          timeTo: '00:00'
        }
      ],

      eventInfo: '',
      contactEmailForEvent: '',
      website: '',
      reservations: '_none',
      ageRange: '',

      // event type
      eventTypes: {
        mediaAndTrade: false,
        onlineEvent: false,
        sherryPairingMenu: false,
        sherryTasting: false,
        sherryCocktails: false,
        sherryTourism: false,
        sherryRetail: false,
        sheryyAcademy: false,
      },

      newsletter: false,
      instagram: '',
      facebook: '',
      twitter: '',

      showInSherry: false,
      termsAndConditions: null,
    };
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions;
    }

    return {
      emailOfEventOrganiser: {email},
      nameOfEvent: {required},
      address: {required},
      postalCode: {required},
      city: {required},
      province: {required},

      contactEmailForEvent: {email},
      website: {url},

      facebook: {url},
      instagram: {url},
      twitter: {url},

      termsAndConditions: {required, termsAgreed}
    };
  },
  methods: {

    hasFile() {
      if (this.files.length && this.files[0].response && this.files[0].response.id) {
        this.nofile = false;
        return true;
      }
      this.nofile = true;
      return false;
    },

    doSuccess() {
      this.success = true;
      //this.scrollToClass('event')
      window.scrollTo(0, 0);
    },

    async submit() {
      const result = await this.v$.$validate();
      if (!result) {
        // notify user form is invalid
        this.scrollToClass('has-text-error-message');
        return;
      }

      const formData = {

        f1: this.f1,
        f2: this.f2,

        nameOfEventOrganiser: this.nameOfEventOrganiser,
        emailOfEventOrganiser: this.emailOfEventOrganiser,
        nameOfEvent: this.nameOfEvent,
        nameOfVenue: this.nameOfVenue,
        country: this.country,
        address: this.address,
        postalCode: this.postalCode,
        city: this.city,
        province: this.province,

        datesAndTimes: this.datesAndTimes,

        eventInfo: this.eventInfo,
        contactEmailForEvent: this.contactEmailForEvent,
        website: this.website,
        reservations: this.reservations,
        ageRange: this.ageRange,

        // event type
        eventTypes: this.eventTypes,

        newsletter: this.newsletter,
        instagram: this.instagram,
        facebook: this.facebook,
        twitter: this.twitter,

        showInSherry: this.showInSherry,
        termsAndConditions: this.termsAndConditions,
        waglocale: this.waglocale

      };

      axios.post("/api/event/", formData)
          .then((res) => {
            console.log(res);
            this.doSuccess();
            // this.success = true;
          })
          .catch((err) => {
            alert("Ha habido un error, contacta con soporte");
          }).finally((err) => {
        this.sending = false;
      });
      ;

    },

    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },

    addDate() {
      console.log(CUR_DATE);
      this.datesAndTimes.push({
        dateFrom: CUR_DATE,
        timeFrom: '00:00',
        dateTo: CUR_DATE,
        timeTo: '00:00'
      });
    },
    removeDate(i) {
      this.datesAndTimes.splice(i, 1);
    },
    async inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file1.active) {
          this.$refs.file1.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },
    async inputFile2(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file2.active) {
          this.$refs.file2.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },

    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {

        if (!newFile.name.match((/(.jpg|.png)$/))) {
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        return prevent();
      }


      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },

  },
  computed: {
    countries() {
      const list = countries.getNames('en', {select: 'official'});
      return Object.keys(list).map((key) => ({value: key, label: list[key]}));
    }
  },

  watch: {
    files: {
      handler: function (files, oldVal) {
        if (files.length > 0 && files[0].response && files[0].response.id) {
          this.f1 = files[0].response.id;
          console.log("this.f1 = ", this.f1);
          return;
        }
        this.f1 = null;
        console.log("this.f1 = ", this.f1);
      },
      deep: true
    },
    files2: {
      handler: function (files2, oldVal) {
        if (files2.length > 0 && files2[0].response && files2[0].response.id) {
          this.f2 = files2[0].response.id;
          return;
        }
        this.f2 = null;

      },
      deep: true
    }
  },
  mounted() {
    this.$i18n.locale = this.lang;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}

</style>